import { css } from "@emotion/css";
import { Fade } from "@mui/material";
import MuiPopover from "@mui/material/Popover";
import type { TransitionProps } from "@mui/material/transitions/transition";
import { themeTokens } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
import { useTransitionComponentOverride } from "../../transition";
import { noOp } from "../../utils";
export type Horizontal = "left" | "center" | "right";
export type Vertical = "top" | "center" | "bottom";
export interface LegacyPopoverOrigin {
    horizontal: Horizontal;
    vertical: Vertical;
}
export interface LegacyPopoverProps {
    anchorEl: Element | null;
    anchorOrigin?: LegacyPopoverOrigin;
    className?: string;
    onClose?: () => void;
    open: boolean;
    transformOrigin?: LegacyPopoverOrigin;
    disableAutoFocus?: boolean;
    disableEnforceFocus?: boolean;
    getUpdatePosition?: (callback: () => void) => void;
    TransitionComponent?: React.ComponentType<TransitionProps>;
    children: React.ReactNode;
}
export function LegacyPopover(props: LegacyPopoverProps) {
    const transitionComponent = useTransitionComponentOverride() ?? props.TransitionComponent ?? Fade; // Default to the same animation used in our global search.
    const classes = {
        paper: css({
            "&&": {
                backgroundColor: themeTokens.color.portal.popover.background,
            },
        }),
    };
    return (<MuiPopover classes={classes} action={(actions) => (props.getUpdatePosition && actions ? props.getUpdatePosition(actions.updatePosition) : noOp())} anchorEl={props.anchorEl} anchorOrigin={props.anchorOrigin} className={props.className} onClose={props.onClose} open={props.open} transformOrigin={props.transformOrigin} disableAutoFocus={props.disableAutoFocus} disableEnforceFocus={props.disableEnforceFocus} TransitionComponent={transitionComponent}>
            {props.children}
        </MuiPopover>);
}
